import PropTypes from 'prop-types';
import { useState } from 'react';
import { useTheme, styled } from '@mui/styles';
import {Button, Grid, Typography } from '@mui/material';
import { Box } from '@mui/system';  // Example import
import MainCard from '../../ui-component/cards/MainCard';
import coverImage from '../../assets/images/bridgestone_images/BRD-Cover.png';


const coverImage1 = 'https://m.media-amazon.com/images/S/aplus-media/vc/f45a4994-3650-44cf-8897-59fc9615d9a4.__CR0,0,970,300_PT0_SX970_V1___.png';

const CardWrapper = styled(MainCard)(({ theme }) => ({
    backgroundImage: `url(${coverImage1})`,
    '&>div': {
        position: 'relative',
        zIndex: 5
    },

}));

// ==============================|| DASHBOARD - TOTAL ORDER LINE CHART CARD ||============================== //

const ImageBanner = ({ isLoading }) => {
    const theme = useTheme();

    const [timeValue, setTimeValue] = useState(false);
    const handleChangeTime = (event, newValue) => {
        setTimeValue(newValue);
    };

    return (
        <>
            <CardWrapper className="cardWrpapper_imagebanner" border={false} content={false}>
                <Box sx={{ p: 2.25 }}>
                </Box>
            </CardWrapper>
        </>
    );
};

ImageBanner.propTypes = {
    isLoading: PropTypes.bool
};

export default ImageBanner;
